

export const newLinkedInCertificateShareData = [
    {
        name: 'Sainath Bavandlapally',
        profileImage: 'https://ik.imagekit.io/238r9emirjj/linkedinpost/1744035431494.jpg?updatedAt=1745562294597',
        role: 'ML Data Associate - II',
        experience: '5-10 Yrs. of Exp.',
        description: <p>I'm happy to share that I've obtained a new certification: Business Analyst Certification from <span className="font-bold text-[#006FBC]">LearnTube.ai!</span></p>,
        post: true,
        certificateImage: 'https://ik.imagekit.io/238r9emirjj/linkedinpost/1718599743366.jpg?updatedAt=1745563304970',
        reactions: 2,
        commentsCount: 2,
        companyName: 'Amazon',
        companyImage: 'https://ik.imagekit.io/238r9emirjj/New%20Recognised%20Section/www_amazon_com-logo-light.svg_white.png?updatedAt=1746275290329',
        style: {
            backgroundImage: 'linear-gradient(to right, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 1) 100%)',
            backgroundColor: '#FB9900'
        },
        linkedinUrl: 'https://www.linkedin.com/posts/sainath-bavandlapally-86124b201_im-happy-to-share-that-ive-obtained-a-new-activity-7208329786824286209-vM60?utm_source=social_share_send&utm_medium=member_desktop_web&rcm=ACoAACRB6WwBFSVP31QAjAkoMoJYiABjYEB_sag',
        comments: [
            {
                author: 'LearnTube.ai',
                authorProfileImage: 'https://ik.imagekit.io/238r9emirjj/linkedinpost/careerninja_logo.jpg?updatedAt=1745563304558',
                role: '30,081 followers',
                description: <p>Congratulations on your achievement Sainath Bavandlapally! Look forward to seeing you continue to grow in your career. Would love to have you share more about your experience with LearnTube😄</p>
            },
            {
                author: 'Darsi Madhukiran',
                authorProfileImage: 'https://ik.imagekit.io/238r9emirjj/linkedinpost/1712201464120.jpg?updatedAt=1745563547016',
                role: 'IT Recruiter at Malvi Systems',
                description: <p>Congratulations!</p>
            },
            
        ],
        icons: [
            'https://ik.imagekit.io/238r9emirjj/linkedinpost/image%20833.png?updatedAt=1745585395146',
            'https://ik.imagekit.io/238r9emirjj/linkedinpost/image%20825.png?updatedAt=1745585476494'
        ]
    },
    {
        name: 'Nikhil Singh',
        profileImage: 'https://ik.imagekit.io/238r9emirjj/linkedinpost/1642956606077.jpg?updatedAt=1745563756773',
        role: 'Quality Assurance Senior Associate',
        experience: '5-10 Yrs. of Exp.',
        description: <p>I earned my certification for completing the Scrum Master assessment by <span className="font-bold text-[#006FBC]">LearnTube.ai!</span> (Career Ninja's Digital Institute).</p>,
        tags: '#learntube #careerninja #scrummaster #agile #sprint',
        post: true,
        certificateImage: 'https://ik.imagekit.io/238r9emirjj/linkedinpost/1728502748455.jpg?updatedAt=1745564160454',
        reactions: 11,
        commentsCount: 8,
        companyName: 'Google',
        companyImage: 'https://ik.imagekit.io/238r9emirjj/New%20Recognised%20Section/www_google_com-logo-dark_white.png?updatedAt=1746275913923',
        style: {
            backgroundColor: '#4289FB'
        },
        linkedinUrl: 'https://www.linkedin.com/feed/update/urn:li:activity:7249865996918763522/?actorCompanyId=13328177',
        comments: [
            {
                author: 'Harshvardhan Singh Gaur',
                authorProfileImage: 'https://ik.imagekit.io/238r9emirjj/linkedinpost/1673369511651.jpg?updatedAt=1745564375948',
                role: 'Generative AI Engineer @ Uber | Driving Scalable AI Solutions at Uber | P',
                description: <p>Wishing you the best</p>
            },
            {
                author: 'Shruti Bollepally',
                authorProfileImage: 'https://ik.imagekit.io/238r9emirjj/linkedinpost/1737716564975.jpg?updatedAt=1745564527797',
                role: 'Quality Assurance Program Manager',
                description: <p>Congrats <span className="font-bold text-[#006FBC]">Nikhil!</span></p>
            },
            
        ],
        icons: [
            'https://ik.imagekit.io/238r9emirjj/linkedinpost/image%20833.png?updatedAt=1745585395146',
            'https://ik.imagekit.io/238r9emirjj/linkedinpost/image%20827.png?updatedAt=1745585542635'
        ]
    },
    {
        name: 'Aditya Bagdare',
        profileImage: 'https://ik.imagekit.io/238r9emirjj/linkedinpost/1735931454957.jpg?updatedAt=1745564600977',
        role: 'Data Analyst I',
        experience: '1-5 Yrs. of Exp.',
        description: <p>I'm happy to share that I've obtained a new certification: Project Management from <span className="font-bold text-[#006FBC]">LearnTube.ai!</span></p>,
        post: true,
        tags:'hashtag#big4 hashtag#consulting hashtag#techconsulting hashtag#MBB hashtag#scrum hashtag#agile',
        issuedOn: 'Issued Apr 2024',
        certificateId: 'PRO-C-3-345234-0Credential ID PRO-C-3-345234-0',
        certificateImage: 'https://ik.imagekit.io/238r9emirjj/linkedinpost/1712893173546.jpg?updatedAt=1745564702546',
        reactions: 17,
        commentsCount: 1,
        caption: 'Landed a US job with',
        companyName: 'FedEx',
        companyImage: 'https://ik.imagekit.io/238r9emirjj/New%20Recognised%20Section/www_fedex_com-logo-light_wh.png?updatedAt=1746276048402',
        style: {
            backgroundImage: 'linear-gradient(to right, #FA7204 0%, #4E1587 100%)'
        },
        linkedinUrl: 'https://www.linkedin.com/in/aditya-bagdare',
        comments: [
            {
                author: 'LearnTube.ai',
                authorProfileImage: 'https://ik.imagekit.io/238r9emirjj/linkedinpost/careerninja_logo.jpg?updatedAt=1745563304558',
                role: '30,081 followers',
                description: <p>Congratulations on completing the course <span className="font-bold text-[#006FBC]">Aditya Bagdare</span></p>
            },
        ],
        icons: [
            'https://ik.imagekit.io/238r9emirjj/linkedinpost/image%20833.png?updatedAt=1745585395146',
            'https://ik.imagekit.io/238r9emirjj/linkedinpost/image%20827.png?updatedAt=1745585542635'
        ]
    },
    {
        name: 'Karthik V',
        profileImage: 'https://ik.imagekit.io/238r9emirjj/linkedinpost/1605015867066.jpg?updatedAt=1745565048101',
        role: 'Sr.Chief Engineer',
        experience: '10+ Yrs. of Exp.',
        description: <p>I'm happy to share that I've obtained a new certification: Certified Associate in Project Management (CAPM) from <span className="font-bold text-[#006FBC]">LearnTube.ai!</span></p>,
        post: true,
        certificateImage: 'https://ik.imagekit.io/238r9emirjj/linkedinpost/1724848145069.jpg?updatedAt=1745565153918',
        reactions: 19,
        commentsCount: 4,
        companyName: 'Samsung',
        companyImage: 'https://ik.imagekit.io/238r9emirjj/New%20Recognised%20Section/samsung_com-logo-light.svg_white.png?updatedAt=1746276215765',
        style: {
            backgroundImage: 'linear-gradient(to right, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 1) 100%)',
            backgroundColor: '#152497'
        },
        linkedinUrl: 'https://www.linkedin.com/feed/update/urn:li:activity:7234537483034615808/?actorCompanyId=13328177',
        comments: [
            {
                author: 'Zoeb Siddiqui',
                authorProfileImage: 'https://ik.imagekit.io/238r9emirjj/linkedinpost/1605194772543.jpg?updatedAt=1745565352998',
                role: 'Infrastructure Project Manager/Program Manager',
                description: <p>Congrats <span className="font-bold text-[#006FBC]">Karthik</span></p>
            },
            {
                author: 'Varun Rajendran',
                authorProfileImage: 'https://ik.imagekit.io/238r9emirjj/linkedinpost/1714027347601.jpg?updatedAt=1745565461122',
                role: 'Senior Chief Engineer at Samsung R&D Institute Bangalore',
                description: <p>Congrats <span className="font-bold text-[#006FBC]">Karthik</span></p>
            },
            
        ],
        icons: [
            'https://ik.imagekit.io/238r9emirjj/linkedinpost/image%20833.png?updatedAt=1745585395146',
            'https://ik.imagekit.io/238r9emirjj/linkedinpost/image%20828.png?updatedAt=1745585650977'
        ]
    },
    {
        name: 'Kumar Saurav',
        profileImage: 'https://ik.imagekit.io/238r9emirjj/linkedinpost/1739813957095.jpg?updatedAt=1745565522867',
        role: 'Senior Project Consultant',
        experience: '5-10 Yrs. of Exp.',
        description: <p>I’m happy to share that I’ve obtained a new certification: Agile Scrum Certifications from <span className="font-bold text-[#006FBC]">LearnTube.ai!</span></p>,
        post: true,
        skillName: 'Certified Scrum Master',
        issuedOn: 'Issued Feb 2024',
        certificateId: 'SCR-C-2-210533-0',
        certificateImage: 'https://ik.imagekit.io/238r9emirjj/linkedinpost/1707986218041.jpg?updatedAt=1745565720472',
        companyName: 'EY',
        companyImage: 'https://ik.imagekit.io/238r9emirjj/New%20Recognised%20Section/www_ey_com-logo-light_wh.png?updatedAt=1746276403856',
        style: {
            backgroundImage: 'linear-gradient(to right, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 1) 100%)',
            backgroundColor: '#D6DF24'
        },
        linkedinUrl: 'https://www.linkedin.com/posts/krsaurav121sxc_im-happy-to-share-that-ive-obtained-a-new-activity-7163813436123009025-xxyH?utm_source=share&utm_medium=member_desktop&rcm=ACoAAEtIIgYBSjM-RVsTqImIW5xZziGlgr6iC9c',
        reactions: 5,
        commentsCount: 1,
        comments: [
            {
                author: 'LearnTube.ai',
                authorProfileImage: 'https://ik.imagekit.io/238r9emirjj/linkedinpost/careerninja_logo.jpg?updatedAt=1745563304558',
                role: '30,081 followers',
                description: <p>Congratulations on completing the course <span className="font-bold text-[#006FBC]">Kumar Saurav</span></p>
            },
        ],
        icons: [
            'https://ik.imagekit.io/238r9emirjj/linkedinpost/image%20833.png?updatedAt=1745585395146',
            'https://ik.imagekit.io/238r9emirjj/linkedinpost/image%20825.png?updatedAt=1745585476494'
        ]
    },
    {
        name: 'Akash Goswami',
        profileImage: 'https://ik.imagekit.io/238r9emirjj/linkedinpost/1740207031737.jpg?updatedAt=1745565913023',
        role: 'Senior Technology Specialist',
        experience: '10+ Yrs. of Exp.',
        description: <p>I'm happy to share that I've obtained a new certification: Scrum master basic quiz from <span className="font-bold text-[#006FBC]">LearnTube.ai!</span></p>,
        post: true,
        certificateImage: 'https://ik.imagekit.io/238r9emirjj/linkedinpost/Group%2022086%20(1).jpg?updatedAt=1746154368636',
        reactions: 24,
        commentsCount: 11,
        companyName: 'Deloitte',
        companyImage: 'https://ik.imagekit.io/238r9emirjj/New%20Recognised%20Section/www_deloitte_com-logo-dark.svg_white.png?updatedAt=1746276563772',
        style: {
            backgroundImage: 'linear-gradient(to right, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 1) 100%)',
            backgroundColor: '#7CB123'
        },
        linkedinUrl: 'https://www.linkedin.com/feed/update/urn:li:activity:7132416685583556608/?actorCompanyId=13328177',
        comments: [
            {
                author: 'Sonal Saurabh',
                authorProfileImage: 'https://ik.imagekit.io/238r9emirjj/linkedinpost/1595340099369.jpg?updatedAt=1745566213803',
                role: 'SAP BTP Architecture | SAP CDC Certified | SA',
                description: <p>Congrats <span className="font-bold text-[#006FBC]">Akash </span>👏👏👏</p>
            },
            {
                author: 'Saumya Ranjan',
                authorProfileImage: 'https://ik.imagekit.io/238r9emirjj/linkedinpost/1744818067588.jpg?updatedAt=1745566364817',
                role: 'Business Analyst||Google Finance||GOOGLE',
                description: <p>Congrats <span className="font-bold text-[#006FBC]">Akash </span></p>
            },
            
        ],
        icons: [
            'https://ik.imagekit.io/238r9emirjj/linkedinpost/image%20833.png?updatedAt=1745585395146',
            'https://ik.imagekit.io/238r9emirjj/linkedinpost/image%20825.png?updatedAt=1745585476494'
        ]
    },
    {
        name: 'Venkatesh Kumar',
        profileImage: 'https://ik.imagekit.io/238r9emirjj/linkedinpost/1718239804118.jpg?updatedAt=1745582269449',
        role: 'Assistant Vice President',
        experience: '10+ Yrs. of Exp.',
        description: <p>Thanks <span className="font-bold text-[#006FBC]">LearnTube.ai!</span></p>,
        post: true,
        certificateImage: 'https://ik.imagekit.io/238r9emirjj/linkedinpost/1723875222959.jpg?updatedAt=1745582370429',
        reactions: 22,
        commentsCount: 5,
        companyName: 'Citi',
        companyImage: 'https://ik.imagekit.io/238r9emirjj/New%20Recognised%20Section/www_citi_com-logo-dark_wh.png?updatedAt=1746276730630',
        style:{
            backgroundImage: 'linear-gradient(to right, #D22A21 0%, #06386D 100%)',
        },
        linkedinUrl: 'https://www.linkedin.com/feed/update/urn:li:activity:7230456750179540993/?actorCompanyId=13328177',
        comments: [
            {
                author: 'Dhinesh K',
                authorProfileImage: 'https://ik.imagekit.io/238r9emirjj/linkedinpost/1666777679497.jpg?updatedAt=1745583061501',
                role: 'Superb VenkiVice President at Citi India',
                description: <p>Superb <span className="font-bold text-[#006FBC]">Venki</span></p>
            },
            {
                author: 'Mahesh Dravidar CSM / CSPO / Business Analyst / Quality Analyst',
                authorProfileImage: 'https://ik.imagekit.io/238r9emirjj/linkedinpost/1674495568841.jpg?updatedAt=1745583206039',
                role: 'Quality Analyst at Concentrix',
                description: <p>Nice <span className="font-bold text-[#006FBC]">Venky</span>👏</p>
            },
            
        ],
        icons: [
            'https://ik.imagekit.io/238r9emirjj/linkedinpost/image%20833.png?updatedAt=1745585395146',
            'https://ik.imagekit.io/238r9emirjj/linkedinpost/image%20827.png?updatedAt=1745585542635'
        ]
    },
    {
        name: 'Abhishek Zine',
        profileImage: 'https://ik.imagekit.io/238r9emirjj/linkedinpost/1745523498585.jpg?updatedAt=1745583303358',
        role: 'WFM Analyst',
        experience: '1-5 Yrs. of Exp.',
        description: <p>I'm happy to share that I've obtained a new certification: Data Analytics using Python from <span className="font-bold text-[#006FBC]">LearnTube.ai!</span></p>,
        tags: '#dataanalytics #datavisualization #python #learntube #careerninja',
        post: true,
        certificateImage: 'https://ik.imagekit.io/238r9emirjj/linkedinpost/1683105374472.jpg?updatedAt=1745583451610',
        reactions: 15,
        commentsCount: 5,
        companyName: 'PhonePe',
        companyImage: 'https://ik.imagekit.io/238r9emirjj/New%20Recognised%20Section/Frame%20427321208.png?updatedAt=1746277117459',
        style: {
            backgroundImage: 'linear-gradient(to right, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 1) 100%)',
            backgroundColor: '#5E259C'
        },
        linkedinUrl: 'https://www.linkedin.com/posts/abhishek-zine_tableaucertified-sqlskills-dataanalytics-activity-7078009963054325760--gWv?utm_source=social_share_send&utm_medium=member_desktop_web&rcm=ACoAACRB6WwBFSVP31QAjAkoMoJYiABjYEB_sag',
        caption: 'Landed this job with',
        comments: [
            {
                author: 'Sandeep Bollaram',
                authorProfileImage: 'https://ik.imagekit.io/238r9emirjj/linkedinpost/1669735074991.jpg?updatedAt=1745583690118',
                role: 'Certified Data Analyst - SkilloVilla | Data Analytics| Power BI | Tableau | SQL',
                description: <p>Congratulations!!!</p>
            },
            {
                author: 'Naresh Rawat',
                authorProfileImage: 'https://ik.imagekit.io/238r9emirjj/linkedinpost/1672322489630.jpg?updatedAt=1745583812683',
                role: 'Management Information System Executive @ Aamor Inox Limited | SAP S/4',
                description: <p>Great to hear this 👏👏</p>
            },
            
        ],
        icons: [
            'https://ik.imagekit.io/238r9emirjj/linkedinpost/image%20833.png?updatedAt=1745585395146',
            'https://ik.imagekit.io/238r9emirjj/linkedinpost/image%20828.png?updatedAt=1745585650977'
        ]
    },
    {
        name: 'Milind Sonar',
        profileImage: 'https://ik.imagekit.io/238r9emirjj/linkedinpost/1728048361337.jpg?updatedAt=1745583916497',
        role: 'Assistant Credit Manager',
        experience: '5-10 Yrs. of Exp.',
        description: <p>Learning always lifts towards an upside. Thanks <span className="font-bold text-[#006FBC]">LearnTube.ai</span></p>,
        tags: '#certificate #excel #data #analysis',
        post: true,
        certificateImage: 'https://ik.imagekit.io/238r9emirjj/linkedinpost/1683788495420.jpg?updatedAt=1745584041858',
        reactions: 22,
        commentsCount: 4,
        companyName: 'HDFC Bank',
        companyImage: 'https://ik.imagekit.io/238r9emirjj/New%20Recognised%20Section/Frame%20427321210.png?updatedAt=1746277380264',
        style: {
            backgroundImage: 'linear-gradient(to right, #E6242D 0%, #0C4A8A 100%)'
        },
        linkedinUrl: 'https://www.linkedin.com/feed/update/urn:li:activity:7062320825009377280/?actorCompanyId=13328177',
        caption: 'Got promoted with',
        comments: [
            {
                author: 'Ritik jain',
                authorProfileImage: 'https://ik.imagekit.io/238r9emirjj/linkedinpost/1730486428305.jpg?updatedAt=1745584316004',
                role: '| Passionate about financial markets, growing my skills in equity research | |',
                description: <p>Congratulations <span className="font-bold text-[#006FBC]">Milind Sonar</span></p>
            },
            {
                author: 'LearnTube.ai',
                authorProfileImage: 'https://ik.imagekit.io/238r9emirjj/linkedinpost/careerninja_logo.jpg?updatedAt=1745563304558',
                role: '30,081 followers',
                description: <p>Congratulations on completing the course <span className="font-bold text-[#006FBC]">Milind Sonar!</span></p>
            },
        ],
        icons: [
            'https://ik.imagekit.io/238r9emirjj/linkedinpost/image%20833.png?updatedAt=1745585395146',
            'https://ik.imagekit.io/238r9emirjj/linkedinpost/image%20825.png?updatedAt=1745585476494'
        ]
    },
    {
        name: 'Shimsha  S M',
        profileImage: 'https://ik.imagekit.io/238r9emirjj/linkedinpost/1729413209697.jpg?updatedAt=1745585175484',
        role: 'Associate Engineer (Krutrim Maps)',
        experience: '1-5 Yrs. of Exp.',
        description: <p>🎓🚀 Exciting news! I recently completed the Introduction to C Programming certificate from <span className="font-bold text-[#006FBC]">LearnTube</span>. This program has been a game-changer for my career. Here are some key skills and knowledge areas I gained while completing this certificate: C programming, debugging techniques, and memory management. I couldn't have achieved this without the amazing mentors and instructors at LearnTube who patiently guided me through the learning process.</p>,
        tags: '#CProgramming #LearnTube #Certificate #CareerBoost #ContinuousLearning #TechSkills #LinkedIn',
        post: true,
        certificateImage: 'https://ik.imagekit.io/238r9emirjj/linkedinpost/1716569931357.jpg?updatedAt=1745584676487',
        reactions: 11,
        commentsCount: 2,
        companyName: 'Ola',
        companyImage: 'https://ik.imagekit.io/238r9emirjj/New%20Recognised%20Section/Frame%20427321209.png?updatedAt=1746277250304',
        style: {
            backgroundImage: 'linear-gradient(to right, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 1) 100%)',
            backgroundColor: '#D6DF24'
        },
        linkedinUrl: 'https://www.linkedin.com/posts/shimsha-s-m-38a801272_cprogramming-learntube-certificate-activity-7199816133439332352-wiKz?utm_source=social_share_send&utm_medium=member_desktop_web&rcm=ACoAACRB6WwBFSVP31QAjAkoMoJYiABjYEB_sag',
        caption: 'Landed this job with',
        comments: [
            {
                author: 'Prajwal A H',
                authorProfileImage: 'https://ik.imagekit.io/238r9emirjj/linkedinpost/1714580369284.jpg?updatedAt=1745584974412',
                role: 'Attended Kuvempu University, Shankaraghatta, Shimoga',
                description: <p>Congratulations 🌟</p>
            },
            {
                author: 'Hemanth S Shankar',
                authorProfileImage: 'https://ik.imagekit.io/238r9emirjj/linkedinpost/1693652534551.jpg?updatedAt=1745585103013',
                role: 'Cyber Security Enthusiast | Immediate joiner | SOC | SPLUNK | S',
                description: <p>Congratulations✨️</p>
            },
        ],
        icons: [
            'https://ik.imagekit.io/238r9emirjj/linkedinpost/image%20833.png?updatedAt=1745585395146',
            'https://ik.imagekit.io/238r9emirjj/linkedinpost/image%20827.png?updatedAt=1745585542635'
        ]
    },
]

export const new3DSlider = [
    'https://ik.imagekit.io/238r9emirjj/linkedinpost/Component%20136.webp?updatedAt=1745649696325',
    'https://ik.imagekit.io/238r9emirjj/linkedinpost/Component%20137.webp?updatedAt=1745649696104',
    'https://ik.imagekit.io/238r9emirjj/linkedinpost/Component%20138.webp?updatedAt=1745649696094',
    'https://ik.imagekit.io/238r9emirjj/linkedinpost/Component%20139.webp?updatedAt=1745649892976',
    'https://ik.imagekit.io/238r9emirjj/new%20Linkedin%20data/Property%201=3.png?updatedAt=1746773868985',
    'https://ik.imagekit.io/238r9emirjj/linkedinpost/Component%20140.webp?updatedAt=1745649892320',
    'https://ik.imagekit.io/238r9emirjj/linkedinpost/Component%20141.webp?updatedAt=1745649892361',
    'https://ik.imagekit.io/238r9emirjj/linkedinpost/Component%20142.png?updatedAt=1745649981938',
    'https://ik.imagekit.io/238r9emirjj/linkedinpost/Component%20136-1.webp?updatedAt=1745649892357',
    'https://ik.imagekit.io/238r9emirjj/linkedinpost/Component%20136-2.webp?updatedAt=1745649892286'
]

export const recognitionSection = [
    {
        name: 'Sainath Bavandlapally',
        profileImage: 'https://ik.imagekit.io/238r9emirjj/recognised_section/1744035431494%20(1).jpg?updatedAt=1745653213999',
        previousOrg: '',
        previousRole: '',
        city: 'Hyderabad',
        finalOrg: 'Amazon',
        finalOrgTitle: 'Amazon',
        showAnimation: false,
        showText: true,
        finalRole: 'ML Data Associate - II',
        statements: ["Completed Business Analyst Certificate", "Shared Certificate to Linkedin", "Growing his career at Amazon"],
        companyImage: 'https://ik.imagekit.io/238r9emirjj/New%20Recognised%20Section/www_amazon_com-symbol-dark_white.png?updatedAt=1746265349125'
    },
    {
        name: 'Nikhil Singh',
        profileImage: 'https://ik.imagekit.io/238r9emirjj/recognised_section/1642956606077.jpg?updatedAt=1745654560176',
        previousOrg: '',
        previousRole: '',
        city: 'Hyderabad',
        finalOrg: 'Google',
        finalOrgTitle: 'Google',
        showAnimation: false,
        showText: true,
        finalRole: 'Quality Assurance Senior Associate',
        statements: ["Completed Scrum Master Certificate", "Li Recognition from pros at Uber, Google", "Growing his career at Google"],
        companyImage: 'https://ik.imagekit.io/238r9emirjj/New%20Recognised%20Section/www_google_com-symbol-dark_white.png?updatedAt=1746265427244'
    },
    {
        name: 'Ankit Dubey',
        profileImage: 'https://ik.imagekit.io/238r9emirjj/recognised_section/1728052184938.jpg?updatedAt=1745655258806',
        previousOrg: '',
        previousRole: '',
        city: 'Delhi',
        finalOrg: 'Adobe',
        finalOrgTitle: 'Adobe',
        showAnimation: false,
        showText: true,
        finalRole: 'Business Analyst- Global Partner strategy and Sales Operations',
        statements: ["Completed Project Management Certificate", "Li Recognition from pros at EY, Flipkart", "Growing his career at Adobe"],
        companyImage: 'https://ik.imagekit.io/238r9emirjj/New%20Recognised%20Section/www_adobe_com-symbol-dark_white.png?updatedAt=1746265487663'
    },
    {
        name: 'Anirudh Saravanan',
        profileImage: 'https://ik.imagekit.io/238r9emirjj/recognised_section/1735201462837.jpg?updatedAt=1745655355305',
        previousOrg: '',
        previousRole: '',
        city: 'Chennai',
        finalOrg: 'Mercedes-Benz India',
        finalOrgTitle: 'Mercedes-Benz India',
        finalRole: 'Senior Engineer',
        showAnimation: false,
        showText: true,
        statements: ["Completed Project Management Certificate", "Li Recognition from Sr. VP at Mercedes", "Growing his career at Mercedes"],
        companyImage: 'https://ik.imagekit.io/238r9emirjj/New%20Recognised%20Section/mercedes_benz_com-logo-light_white.png?updatedAt=1746265542811'
    },
    {
        name: 'Aditya Bagdare',
        profileImage: 'https://ik.imagekit.io/238r9emirjj/recognised_section/1735931454957.jpg?updatedAt=1745655545521',
        previousOrg: 'ICICI Prudential Life Insurance Company Limited',
        previousRole: 'Data Visualisation: Empowering Business with Effective Insights',
        city: 'Mumbai',
        finalOrg: 'FedEx',
        finalOrgTitle: 'FedEx',
        showAnimation: true,
        showText: false,
        finalRole: 'Data Visualisation Specialist',
        statements: ["Completed Advance Excel Certificate", "Added Certificate to his resume", "Landed a job at FedEx US"],
        companyImage: 'https://ik.imagekit.io/238r9emirjj/New%20Recognised%20Section/www_fedex_com-logo-light_white%20(2).png?updatedAt=1746265608976'
    },
    {
        name: 'Kumar Saurav',
        profileImage: 'https://ik.imagekit.io/238r9emirjj/recognised_section/1739813957095.jpg?updatedAt=1745655870110',
        previousOrg: '',
        previousRole: '',
        city: 'Bengaluru',
        finalOrg: 'EY',
        finalOrgTitle: 'EY',
        showAnimation: false,
        showText: false,
        finalRole: 'Senior Project Consultant',
        statements: ["Completed Scrum Master Certificate", "Li Recognition from Manager at HSBC", "Growing his career at Ernst & Young"],
        companyImage: 'https://ik.imagekit.io/238r9emirjj/New%20Recognised%20Section/www_ey_com-logo-dark_white.png?updatedAt=1746265670995'
    },
    {
        name: 'Shweta Singh',
        profileImage: 'https://ik.imagekit.io/238r9emirjj/New%20Landing%20Page/image.png?updatedAt=1744024275926',
        previousOrg: 'Accenture',
        previousRole: 'Data Analyst',
        city: 'Mumbai',
        finalOrg: 'Baker Hughes',
        finalOrgTitle: 'Baker Hughes',
        finalRole: 'Data Analyst',
        showAnimation: true,
        showText: true,
        statements: ["Completed Data Science Certificate", "20+ interviews unlocked with Certification", "Got 150% salary hike at Baker Hughes US"],
        companyImage: 'https://ik.imagekit.io/238r9emirjj/New%20Recognised%20Section/www_bakerhughes_com-symbol-dark_white%20(1).png?updatedAt=1746265717718'
    },
    {
        name: 'Karthik V',
        profileImage: 'https://ik.imagekit.io/238r9emirjj/New%20Recognised%20Section/1605015867066.jpg?updatedAt=1746273338826',
        previousOrg: '',
        previousRole: '',
        city: 'Bengaluru',
        finalOrg: 'Samsung R&D Institute India',
        finalOrgTitle: 'Samsung R&D Institute India',
        finalRole: 'Sr.Chief Engineer',
        showAnimation: false,
        showText: false,
        statements: ["Completed Python Certificate", "Li Recognition from 15+ colleagues", "Growing career at Samsung"],
        companyImage: 'https://ik.imagekit.io/238r9emirjj/New%20Recognised%20Section/samsung_com-logo-dark_white.png?updatedAt=1746273456378'
    },
    {
        name: 'Kumar Vaibhav',
        profileImage: 'https://ik.imagekit.io/238r9emirjj/recognised_section/1740119553553.jpg?updatedAt=1746154650158',
        previousOrg: '',
        previousRole: '',
        city: 'Hyderabad',
        finalOrg: 'Safe Security, ex-Uber',
        finalOrgTitle: 'Uber',
        showAnimation: false,
        showText: false,
        finalRole: 'Product Experience Manager',
        statements: ["Completed Product Management Certificate", "Li Recognition from CPO at Camunda US", "Growing his PM career at Safe Security"],
        companyImage: 'https://ik.imagekit.io/238r9emirjj/New%20Recognised%20Section/uber_com-logo-dark_white.png?updatedAt=1746273098349'
    },
    {
        name: 'Rohan Dive',
        profileImage: 'https://ik.imagekit.io/238r9emirjj/New%20Recognised%20Section/1732038981422.jpg?updatedAt=1746427695518',
        previousOrg: '',
        previousRole: '',
        city: 'Japan',
        finalOrg: 'Walmart',
        finalOrgTitle: 'Walmart',
        finalRole: 'Business Analyst',
        showAnimation: false,
        showText: false,
        statements: ["Completed Introduction to Python Certificate", "Shared Certificate to Linkedin", "Growing career at Walmart"],
        companyImage: 'https://ik.imagekit.io/238r9emirjj/New%20Recognised%20Section/Walmart.png?updatedAt=1746427878057'
    },
    {
        name: 'Mallakunta Tharun Kumar',
        profileImage: 'https://ik.imagekit.io/238r9emirjj/recognised_section/1741745368780.jpg?updatedAt=1746154850842',
        previousOrg: 'eBlackbucks Group🦌',
        previousRole: 'Intern',
        city: 'Bengaluru',
        finalOrg: 'Dell Technologies',
        finalOrgTitle: 'Dell Technologies',
        finalRole: 'Software Engineer',
        showAnimation: true,
        showText: false,
        statements: ["Completed HTML Certificate", "Added Certificate to Resume", "Landed first job at Dell"],
        companyImage: 'https://ik.imagekit.io/238r9emirjj/New%20Recognised%20Section/www_dell_com-other-light_white%20(1).png?updatedAt=1746265830189'
    },
    {
        name: 'Abhishek Pratap Singh',
        profileImage: 'https://ik.imagekit.io/238r9emirjj/recognised_section/1743448722424.jpg?updatedAt=1746155403401',
        previousOrg: '',
        previousRole: '',
        city: 'Noida',
        finalOrg: 'HCLTech',
        finalOrgTitle: 'HCLTech',
        finalRole: 'Lead Analyst',
        showAnimation: false,
        showText: false,
        statements: ["Completed Project Management Certificate", "Shared Certificate to Linkedin", "Growing career at HCLTech"],
        companyImage: 'https://ik.imagekit.io/238r9emirjj/New%20Recognised%20Section/www_hcltech_com-logo-dark_white.png?updatedAt=1746265909135'
    },
    {
        name: 'Antra Soni',
        profileImage: 'https://ik.imagekit.io/238r9emirjj/recognised_section/1710413707682.jpg?updatedAt=1746155577860',
        previousOrg: 'Adani Airport Holdings Ltd · Internship',
        previousRole: 'Summer Intern',
        city: 'Ghaziabad',
        finalOrg: 'KPMG India',
        finalOrgTitle: 'KPMG India',
        finalRole: 'Analyst',
        showAnimation: true,
        showText: false,
        statements: ["Completed Azure Cloud Certificate", "Added Certificate to Resume", "Landed first job at KPMG"],
        companyImage: 'https://ik.imagekit.io/238r9emirjj/New%20Recognised%20Section/www_kpmg_com-logo-dark_white.png?updatedAt=1746265970747'
    },
    {
        name: 'Akash Goswami',
        profileImage: 'https://ik.imagekit.io/238r9emirjj/recognised_section/1740207031737.jpg?updatedAt=1746155755497',
        previousOrg: 'Capgemini',
        previousRole: 'Manager',
        city: 'Kolkata',
        finalOrg: 'Deloitte',
        finalOrgTitle: 'Deloitte',
        finalRole: 'Senior Technology Specialist',
        showAnimation: true,
        showText: false,
        statements: ["Completed Scrum Master Certificate", "Li Recognition from Global Mngr. US +20", "Landed a job at Deloitte"],
        companyImage: 'https://ik.imagekit.io/238r9emirjj/New%20Recognised%20Section/www_deloitte_com-logo-dark_white.png?updatedAt=1746266153751'
    },
    {
        name: 'Anusha Surathkal',
        profileImage: 'https://ik.imagekit.io/238r9emirjj/recognised_section/1710043325292.jpg?updatedAt=1746155916967',
        previousOrg: '',
        previousRole: '',
        city: 'Bengaluru',
        finalOrg: 'PwC',
        finalOrgTitle: 'PwC',
        showText: false,
        finalRole: 'Strategic Content & Operations Administrator',
        showAnimation: false,
        statements: ["Completed Project Management Certificate", "Li 👏 from Assc. Director, BioCentury US", "Growing career at PwC"],
        companyImage: 'https://ik.imagekit.io/238r9emirjj/New%20Recognised%20Section/www_pwc_com-logo-dark_white%20(1).png?updatedAt=1746266219557'
    },
    {
        name: 'V. RaviKiran Bejjanki',
        profileImage: 'https://ik.imagekit.io/238r9emirjj/recognised_section/1724425944171.jpg?updatedAt=1746156089446',
        previousOrg: 'Centre for Sight',
        previousRole: 'Deputy Manager – Lead Management Team',
        city: 'Delhi',
        finalOrg: 'Forrester',
        finalOrgTitle: 'Forrester',
        finalRole: 'Manager, Customer Success Services (capitalisation)',
        showAnimation: true,
        showText: false,
        statements: ["Completed Project Management Certificate", "Li Recognition from pros at KPMG, Samsung", "Landed a job at Forrester"],
        companyImage: 'https://ik.imagekit.io/238r9emirjj/New%20Recognised%20Section/www_forrester_com-logo-dark_white%20(1).png?updatedAt=1746266274735'
    },
    {
        name: 'Rahul Mathevan',
        profileImage: 'https://ik.imagekit.io/238r9emirjj/recognised_section/1611814163892.jpg?updatedAt=1746156266095',
        previousOrg: '',
        previousRole: '',
        city: 'Chennai',
        finalOrg: "Moody's, ex-McKinsey",
        finalOrgTitle: "McKinsey",
        finalRole: 'Senior Production Associate',
        showAnimation: false,
        showText: false,
        statements: ["Completed Product Management Certificate", "Li Recognition from pros at Barclay's +10", "Growing career at Moody's Investors Service"],
        companyImage: 'https://ik.imagekit.io/238r9emirjj/New%20Recognised%20Section/mckinsey_com-logo-light_white.png?updatedAt=1746426229880'
    },
    {
        name: 'Aaksweta Ray',
        profileImage: 'https://ik.imagekit.io/238r9emirjj/recognised_section/1621020078379.jpg?updatedAt=1746156486146',
        previousOrg: '',
        previousRole: '',
        city: 'Bengaluru',
        finalOrg: "Accenture, ex-Wipro",
        finalOrgTitle: "Wipro",
        finalRole: 'Business Process Analyst',
        showAnimation: false,
        showText: false,
        statements: ["Completed Product Management Certificate", "Li Recognition from pros at Amazon", "Growing career at Accenture"],
        companyImage: 'https://ik.imagekit.io/238r9emirjj/New%20Recognised%20Section/wipro_com-logo-dark_white%20(1).png?updatedAt=1746425955870'
    },
    {
        name: 'Rohan Kulkarni',
        profileImage: 'https://ik.imagekit.io/238r9emirjj/recognised_section/1647630418876.jpg?updatedAt=1746157895902',
        previousOrg: 'Cognizant',
        previousRole: 'Technical Lead',
        city: 'Pune',
        finalOrg: "Accenture",
        finalOrgTitle: "Accenture",
        finalRole: 'Service Manager',
        showAnimation: true,
        showText: true,
        statements: ["Completed Product Management Certificate", "Li Recognition from Crowstrike, Cognizant", "Landed a job at Accenture"],
        companyImage: 'https://ik.imagekit.io/238r9emirjj/New%20Recognised%20Section/www_accenture_com-symbol-dark_white%20(1).png?updatedAt=1746266410604'
    },
    {
        name: 'Rishabh Singh',
        profileImage: 'https://ik.imagekit.io/238r9emirjj/recognised_section/1707274629746.jpg?updatedAt=1746157089980',
        previousOrg: '',
        previousRole: '',
        city: 'Delhi',
        finalOrg: "Aon",
        finalOrgTitle: "Aon",
        finalRole: 'IND Intern',
        showAnimation: false,
        showText: false,
        statements: ["Completed SQL Certificate", "Li Recognition from peers at Visa, Amex", "Growing career at Aon"],
        companyImage: 'https://ik.imagekit.io/238r9emirjj/New%20Recognised%20Section/www_aon_com-logo-dark_white.png?updatedAt=1746266501341'
    },
    {
        name: 'Venkatesh Kumar',
        profileImage: 'https://ik.imagekit.io/238r9emirjj/recognised_section/1718239804118.jpg?updatedAt=1746157284988',
        previousOrg: '',
        previousRole: '',
        city: 'Chennai',
        finalOrg: "Citi",
        finalOrgTitle: "Citi",
        finalRole: 'Assistant Vice President',
        showText: false,
        showAnimation: false,
        statements: ["Completed Six Sigma Certificate", "Li Recognition from VP @ Citi IE", "Growing career at Citi"],
        companyImage: 'https://ik.imagekit.io/238r9emirjj/New%20Recognised%20Section/www_citi_com-logo-dark_white.png?updatedAt=1746266551176'
    },
    {
        name: 'Sai Badrish',
        profileImage: 'https://ik.imagekit.io/238r9emirjj/recognised_section/1537677823848.jpg?updatedAt=1746158062649',
        previousOrg: '',
        previousRole: '',
        city: 'Bengaluru',
        finalOrg: "Standard Chartered Bank",
        finalOrgTitle: "Standard Chartered Bank",
        finalRole: 'Technical Lead',
        showAnimation: false,
        showText: true,
        statements: ["Completed Tableau Certificate", "Li Recognition from Sr. Lead ML Engineer", "Growing career at Standard Chartered Bank"],
        companyImage: 'https://ik.imagekit.io/238r9emirjj/New%20Recognised%20Section/www_sc_com-symbol-dark_white.png?updatedAt=1746273031072'
    },
    {
        name: 'Prayas Aute',
        profileImage: 'https://ik.imagekit.io/238r9emirjj/New%20Recognised%20Section/1616216183959.jpg?updatedAt=1746427990975',
        previousOrg: '',
        previousRole: '',
        city: 'Pune',
        finalOrg: "Mastercard",
        finalOrgTitle: "Mastercard",
        finalRole: 'Senior Project Manager',
        showAnimation: false,
        showText: true,
        statements: ["Completed Introduction to Python Certificate", "Shared Certificate to Linkedin", "Landed a job at Mastercard"],
        companyImage: 'https://ik.imagekit.io/238r9emirjj/New%20Recognised%20Section/Mastercard.png?updatedAt=1746429731530'
    },
    {
        name: 'Chandan Jaiswal',
        profileImage: 'https://ik.imagekit.io/238r9emirjj/recognised_section/1685091144073.jpg?updatedAt=1746158686877',
        previousOrg: '',
        previousRole: '',
        city: 'Delhi',
        finalOrg: "Barclays",
        finalOrgTitle: "Barclays",
        finalRole: 'Deputy Manager',
        showAnimation: false,
        showText: true,
        statements: ["Completed Project Management Certificate", "Li Recognition from ThermoFisher 🇳🇱", "Growing career at Barclays"],
        companyImage: 'https://ik.imagekit.io/238r9emirjj/New%20Recognised%20Section/www_barclays_com-symbol-dark_white%20(1).png?updatedAt=1746266741491'
    },
    {
        name: 'Milind Sonar',
        profileImage: 'https://ik.imagekit.io/238r9emirjj/recognised_section/1746028824711.jpg?updatedAt=1746158920275',
        previousOrg: 'HDFC Bank',
        previousRole: 'Trainee Credit Manager',
        city: 'Pune',
        finalOrg: 'HDFC Bank',
        finalOrgTitle: "HDFC Bank",
        finalRole: 'Assistant Credit Manager',
        showAnimation: true,
        showText: true,
        statements: ["Completed Excel Data Analysis Certificate", "Shared Certificate to Linkedin", "Promoted to Assistant Credit Manager"],
        companyImage: 'https://ik.imagekit.io/238r9emirjj/New%20Recognised%20Section/HDFC.png?updatedAt=1746266815095'
    },
    {
        name: 'Suraj Morgaonkar',
        profileImage: 'https://ik.imagekit.io/238r9emirjj/recognised_section/1718242674339.jpg?updatedAt=1746159229735',
        previousOrg: 'Netwin Systems',
        previousRole: 'Marketing Executive Head - Goa Region',
        city: 'South Goa',
        finalOrg: "Axis Max Life Insurance",
        finalOrgTitle: "Axis Max Life Insurance",
        finalRole: 'Agency Development Manager',
        showAnimation: true,
        showText: true,
        statements: ["Completed Scrum Master Certificate", "Li Recognition from Amazon, Boeing, Hilton", "Landed a job at Axis Max Life Insurance Limited"],
        companyImage: 'https://ik.imagekit.io/238r9emirjj/New%20Recognised%20Section/www_axisbank_com-symbol-dark_white.png?updatedAt=1746266867292'
    },
    {
        name: 'Hariprasad R',
        profileImage: 'https://ik.imagekit.io/238r9emirjj/recognised_section/1678429481532.jpg?updatedAt=1746159830668',
        previousOrg: '',
        previousRole: '',
        city: 'Bengaluru',
        finalOrg: "Wells Fargo",
        finalOrgTitle: "Wells Fargo",
        finalRole: 'Sr. Assistant Vice President',
        showAnimation: false,
        showText: false,
        statements: ["Completed Data Analytics Certificate", "Shared Certificate to Linkedin", "Growing career at Wells Fargo"],
        companyImage: 'https://ik.imagekit.io/238r9emirjj/New%20Recognised%20Section/www_wellsfargo_com-logo-dark_white.png?updatedAt=1746266927717'
    },
    {
        name: 'Abhinav Gupta',
        profileImage: 'https://ik.imagekit.io/238r9emirjj/recognised_section/1735831902106.jpg?updatedAt=1746159567277',
        previousOrg: 'SAPRO',
        previousRole: 'Operations Lead',
        city: 'India',
        finalOrg: "HSBC",
        finalOrgTitle: "HSBC",
        finalRole: 'AVP',
        showAnimation: true,
        showText: true,
        statements: ["Completed Project Management Certificate", "Li Recognition from COO, CXO, Sapro US", "Landed a job at HSBC"],
        companyImage: 'https://ik.imagekit.io/238r9emirjj/New%20Recognised%20Section/www_hsbc_com-symbol-light_white%20(1).png?updatedAt=1746266984136'
    },
    {
        name: 'Saptarshi Das',
        profileImage: 'https://ik.imagekit.io/238r9emirjj/recognised_section/1733074340143%20(1).jpg?updatedAt=1746160302153',
        previousOrg: 'Sutherland',
        previousRole: 'Lead IT Help Desk',
        city: 'Bengaluru',
        finalOrg: "Infosys",
        finalOrgTitle: "Infosys",
        finalRole: 'Team Leader',
        showAnimation: true,
        showText: false,
        statements: ["Completed Project Management Certificate", "Shared Certificate to Linkedin", "Landed a job at Infosys with a 42% Salary hike"],
        companyImage: 'https://ik.imagekit.io/238r9emirjj/New%20Recognised%20Section/www_infosys_com-logo-light_white%20(1).png?updatedAt=1746267038902'
    },
    {
        name: 'Mohammed Haris',
        profileImage: 'https://ik.imagekit.io/238r9emirjj/recognised_section/1727640337534.jpg?updatedAt=1746160524054',
        previousOrg: 'CRED',
        previousRole: 'Associate',
        city: 'Bengaluru',
        finalOrg: "CRED",
        finalOrgTitle: "CRED",
        finalRole: 'Hierarchical Escalations',
        showAnimation: true,
        showText: false,
        statements: ["Completed Business Analyst Certificate", "Added Certificate to Resume", "Promoted to Hierarchical Escalations"],
        companyImage: 'https://ik.imagekit.io/238r9emirjj/New%20Recognised%20Section/www_cred_club-logo-light_white%20(1).png?updatedAt=1746267089691'
    },
    {
        name: 'Shimsha  S M',
        profileImage: 'https://ik.imagekit.io/238r9emirjj/linkedinpost/1729413209697.jpg?updatedAt=1745585175484',
        previousOrg: 'Kuvempu Unversity',
        previousRole: 'Masters',
        city: 'Bengaluru',
        finalOrg: "Ola",
        finalOrgTitle: "Ola",
        finalRole: 'Associate Engineer (Krutrim Maps)',
        showAnimation: true,
        showText: false,
        statements: ["Completed Oracle Cloud Infrastructure Certificate", "Added Certificate to Resume", "Landed a job at Ola"],
        companyImage: 'https://ik.imagekit.io/238r9emirjj/New%20Recognised%20Section/OLA.png?updatedAt=1746267140043'
    },
    {
        name: 'Surajit Dan',
        profileImage: 'https://ik.imagekit.io/238r9emirjj/recognised_section/1699512511869.jpg?updatedAt=1746160969362',
        previousOrg: 'Zomato',
        previousRole: 'Fleet Operations Manager',
        city: 'Kolkata',
        finalOrg: "Zomato",
        finalOrgTitle: "Zomato",
        finalRole: 'Area Lead',
        showAnimation: true,
        showText: false,
        statements: ["Completed Project Management Certificate", "Li Recognition from PwC, Blinkit", "Promoted to Area Lead"],
        companyImage: 'https://ik.imagekit.io/238r9emirjj/New%20Recognised%20Section/www_zomato_com-logo-dark_white.png?updatedAt=1746267227819'
    },
    {
        name: 'Suman Kumar Singh',
        profileImage: 'https://ik.imagekit.io/238r9emirjj/recognised_section/1738873583207.jpg?updatedAt=1746161449623',
        previousOrg: '',
        previousRole: '',
        city: 'Bengaluru',
        finalOrg: "CARS24",
        finalOrgTitle: "CARS24",
        finalRole: 'General Manager (Retail & Sales Head)',
        showAnimation: false,
        showText: false,
        statements: ["Completed Project Management Certificate", "Li Recognition from Harper-Collins", "Growing career at CARS24"],
        companyImage: 'https://ik.imagekit.io/238r9emirjj/New%20Recognised%20Section/www_cars24_com-logo-dark_white%20(1)%20(1).png?updatedAt=1746267298882'
    },
    {
        name: 'Bhavya  Verma',
        profileImage: 'https://ik.imagekit.io/238r9emirjj/recognised_section/1742321576614.jpg?updatedAt=1746161733680',
        previousOrg: 'PSIT COLLEGE OF ENGINEERING, KANPUR',
        previousRole: 'BTech, CS AIML',
        city: 'Bengaluru',
        finalOrg: "Flipkart",
        finalOrgTitle: "Flipkart",
        finalRole: 'Application Engineer',
        showAnimation: true,
        showText: false,
        statements: ["Completed Machine Learning Core Essentials Certificate", "Li Recognition from Turing, Capgemini", "Landed a job at Flipkart"],
        companyImage: 'https://ik.imagekit.io/238r9emirjj/New%20Recognised%20Section/Flipkart.png?updatedAt=1746268316885'
    },
    {
        name: 'Tarun Negi',
        profileImage: 'https://ik.imagekit.io/238r9emirjj/recognised_section/1707482947073.jpg?updatedAt=1746167091736',
        previousOrg: '',
        previousRole: '',
        city: 'Noida',
        finalOrg: "Paytm",
        finalOrgTitle: "Paytm",
        finalRole: 'Senior Associate',
        showAnimation: false,
        showText: true,
        statements: ["Completed Project Management Certificate", "Li Recognition from Leaders at Paytm", "Growing career at Paytm"],
        companyImage: 'https://ik.imagekit.io/238r9emirjj/New%20Recognised%20Section/www_paytm_com-logo-dark_white.png?updatedAt=1746268364141'
    },
    {
        name: 'Anmol ‌‌‍Rane',
        profileImage: 'https://ik.imagekit.io/238r9emirjj/recognised_section/1735051622434.jpg?updatedAt=1746167657071',
        previousOrg: 'StunHaul',
        previousRole: 'HR Manager',
        city: 'India',
        finalOrg: "Unacademy",
        finalOrgTitle: "Unacademy",
        finalRole: 'Growth Specialist',
        showAnimation: true,
        showText: true,
        statements: ["Completed Introduction to Data Analytics Certificate", "Shared Certificate to Linkedin", "Landed a job at Unacademy"],
        companyImage: 'https://ik.imagekit.io/238r9emirjj/New%20Recognised%20Section/Unacademy.png?updatedAt=1746268418866'
    },
    {
        name: 'Snehil Ashish',
        profileImage: 'https://ik.imagekit.io/238r9emirjj/recognised_section/1681793205736.jpg?updatedAt=1746168710927',
        previousOrg: '',
        previousRole: '',
        city: 'Bengaluru',
        finalOrg: "upGrad",
        finalOrgTitle: "upGrad",
        finalRole: 'Senior Operations Analyst',
        showAnimation: false,
        showText: false,
        statements: ["Completed Project Management Certificate", "Li Recognition from Program Manager, ISB", "Growing career at upGrad"],
        companyImage: 'https://ik.imagekit.io/238r9emirjj/New%20Recognised%20Section/www_upgrad_com-logo-dark_white.png?updatedAt=1746268468714'
    },
    {
        name: 'Ishan Dev Shukl',
        profileImage: 'https://ik.imagekit.io/238r9emirjj/recognised_section/1742044922364.jpg?updatedAt=1746168881016',
        previousOrg: '',
        previousRole: '',
        city: 'Gurgaon',
        finalOrg: "Nykaa",
        finalOrgTitle: "Nykaa",
        finalRole: 'SDET Manager',
        showAnimation: false,
        showText: false,
        statements: ["Completed Scrum Master Basic Certificate", "Li Recognition from DE Shaw, Postman", "Growing career at Nykaa"],
        companyImage: 'https://ik.imagekit.io/238r9emirjj/New%20Recognised%20Section/www_nykaa_com-logo-dark_white%20(1).png?updatedAt=1746268520813'
    },
    {
        name: 'Shounak Singh',
        profileImage: 'https://ik.imagekit.io/238r9emirjj/recognised_section/1697824186285.jpg?updatedAt=1746169123698',
        previousOrg: '',
        previousRole: '',
        city: 'Gurgaon',
        finalOrg: "ixigo",
        finalOrgTitle: "ixigo",
        finalRole: 'Senior Manager - Partnerships',
        showAnimation: false,
        showText: false,
        statements: ["Completed Project Management Certificate", "Li Recognition from Paytm, MakeMyTrip", "Growing career at ixigo"],
        companyImage: 'https://ik.imagekit.io/238r9emirjj/New%20Recognised%20Section/www_ixigo_com-logo-dark_white%20(2).png?updatedAt=1746268574984'
    },
    {
        name: 'Sachin Kumar Mahto',
        profileImage: 'https://ik.imagekit.io/238r9emirjj/recognised_section/1547213326368.jpg?updatedAt=1746169273128',
        previousOrg: '',
        previousRole: '',
        city: 'Jamshedpur',
        finalOrg: "Swiggy",
        finalOrgTitle: "Swiggy",
        finalRole: 'Chat support executive',
        showAnimation: false,
        showText: true,
        statements: ["Completed Microinteractions Certificate", "Li Recognition from Founder, FourDots", "Growing career at Swiggy"],
        companyImage: 'https://ik.imagekit.io/238r9emirjj/New%20Recognised%20Section/www_swiggy_com-symbol-dark_white%20(1).png?updatedAt=1746268622453'
    },
    {
        name: 'Rinku Majumdar',
        profileImage: 'https://ik.imagekit.io/238r9emirjj/recognised_section/1725012091229.jpg?updatedAt=1746169502393',
        previousOrg: '',
        previousRole: '',
        city: 'Bengaluru',
        finalOrg: "Samaaro, ex-Jupiter",
        finalOrgTitle: "Jupiter",
        finalRole: 'Customer Success Manager',
        showAnimation: false,
        showText: false,
        statements: ["Completed Introduction to Project Management Certificate", "Shared Certificate to Linkedin", "Growing career at Samaaro"],
        companyImage: 'https://ik.imagekit.io/238r9emirjj/New%20Recognised%20Section/www_jupiter_com-logo-light_white.png?updatedAt=1746273226370'
    },
    {
        name: 'Vishnu Sathikumar',
        profileImage: 'https://ik.imagekit.io/238r9emirjj/recognised_section/1739848066260.jpg?updatedAt=1746169734023',
        previousOrg: '',
        previousRole: '',
        city: 'Bengaluru',
        finalOrg: "udaan.com",
        finalOrgTitle: "udaan.com",
        finalRole: 'Associate Manager',
        showAnimation: false,
        showText: true,
        statements: ["Completed Project Management Certificate", "Li Recognition from Assoc. Director, Udaan", "Growing career at udaan.com"],
        companyImage: 'https://ik.imagekit.io/238r9emirjj/New%20Recognised%20Section/Udaan.png?updatedAt=1746268718462'
    },
    {
        name: 'Piyush Singh',
        profileImage: 'https://ik.imagekit.io/238r9emirjj/recognised_section/1737906681773.jpg?updatedAt=1746169952925',
        previousOrg: 'Flipkart',
        previousRole: 'Operation Executive',
        city: 'Jaipur',
        finalOrg: "Meesho",
        finalOrgTitle: "Meesho",
        finalRole: 'Area Operation Manager',
        showAnimation: true,
        showText: false,
        statements: ["Completed Search Engine Marketing Basics Certificate", "Li Recognition from pros at Amazon, Myntra", "Landed a job at Meesho"],
        companyImage: 'https://ik.imagekit.io/238r9emirjj/New%20Recognised%20Section/www_meesho_com-logo-dark_white%20(1).png?updatedAt=1746268774146'
    },
    {
        name: 'Sourav Sharma',
        profileImage: 'https://ik.imagekit.io/238r9emirjj/recognised_section/1718284268971.jpg?updatedAt=1746170205404',
        previousOrg: 'WiseX',
        previousRole: 'Product Manager',
        city: 'Faridabad',
        finalOrg: "Freecharge",
        finalOrgTitle: "Freecharge",
        finalRole: 'Lead Business Analyst',
        showAnimation: true,
        showText: false,
        statements: ["Completed Scrum Master Basic Certificate", "Li Recognition from AVP @ MapMyIndia", "Landed a job at Freecharge"],
        companyImage: 'https://ik.imagekit.io/238r9emirjj/New%20Recognised%20Section/www_freecharge_com-logo-dark_white.png?updatedAt=1746268829685'
    },
    {
        name: 'Himanshu Sinha',
        profileImage: 'https://ik.imagekit.io/238r9emirjj/recognised_section/1716132382198.jpg?updatedAt=1746170425591',
        previousOrg: '',
        previousRole: '',
        city: 'Dubai',
        finalOrg: "noon, ex-Shadowfax",
        finalOrgTitle: "Shadowfax",
        finalRole: 'Cluster Manager - Logistics',
        showAnimation: false,
        showText: true,
        statements: ["Completed Project Management Certificate", "Li Recognition from Amazon, Flipkart", "Landed a job at noon"],
        companyImage: 'https://ik.imagekit.io/238r9emirjj/New%20Recognised%20Section/Shadowfax.png?updatedAt=1746272980237'
    },
    {
        name: 'Kamal Singh',
        profileImage: 'https://ik.imagekit.io/238r9emirjj/recognised_section/1677751685877.jpg?updatedAt=1746170684043',
        previousOrg: '',
        previousRole: '',
        city: 'New Delhi',
        finalOrg: "Rastey, ex-Treebo Hotels",
        finalOrgTitle: "Treebo Hotels",
        finalRole: 'Hotel Operations Manager',
        showAnimation: false,
        showText: true,
        statements: ["Completed Project Management Certificate", "Added Certificate to Resume", "Landed a job at Rastey Commuting Services (P)Limited"],
        companyImage: 'https://ik.imagekit.io/238r9emirjj/New%20Recognised%20Section/Treebo.png?updatedAt=1746272899498'
    },
    {
        name: 'Arun Muthukrishnan',
        profileImage: 'https://ik.imagekit.io/238r9emirjj/recognised_section/1517420457144.jpg?updatedAt=1746171226719',
        previousOrg: '',
        previousRole: '',
        city: 'Chennai',
        finalOrg: "NoBroker.com",
        finalOrgTitle: "NoBroker.com",
        finalRole: 'Senior Business Performance Consultant',
        showAnimation: false,
        showText: true,
        statements: ["Completed Scrum Master Basics Certificate", "Li Recognition from Amazon, Zoho, Ford", "Growing career at NoBroker.com"],
        companyImage: 'https://ik.imagekit.io/238r9emirjj/New%20Recognised%20Section/NoBroker.png?updatedAt=1746268955925'
    },
    {
        name: 'Abdurrahman Shaik',
        profileImage: 'https://ik.imagekit.io/238r9emirjj/recognised_section/1744921943408.jpg?updatedAt=1746171515971',
        previousOrg: '',
        previousRole: '',
        city: 'Bengaluru',
        finalOrg: "MyGate",
        finalOrgTitle: "MyGate",
        finalRole: 'Senior Manager',
        showAnimation: false,
        showText: false,
        statements: ["Completed Project Management Certificate", "Li Recognition from Manager, PhonePe", "Growing career at MyGate"],
        companyImage: 'https://ik.imagekit.io/238r9emirjj/New%20Recognised%20Section/www_mygate_com-logo-light_white%20(1).png?updatedAt=1746269017358'
    },
]

export const newlinkedInPostData = [
    {
        "url": "https://www.linkedin.com/posts/abhinav-anand23_excited-to-share-that-i-have-successfully-activity-7178568763091378178-sOD4?utm_source=combined_share_message&utm_medium=member_desktop&rcm=ACoAACS53IQBRp5abUfab-KaJVp7bO9mCo7vR0I",
        "authorName": "Abhinav Anand",
        "authorDescription": "Senior Associate at PwC | IIM Alumnus | Project Management | Agile - Scrum | Jira | Confluence | Microsoft 365 | PowerBI | SQL | GenAI | Prompt Engineering | Data Analyst | Guidewire",
        "authorProfileImage": "https://ik.imagekit.io/238r9emirjj/new%20Linkedin%20data/1714469330808.jpg?updatedAt=1746707842285",
        "authorProfileLink": "https://www.linkedin.com/in/abhinav-anand23?miniProfileUrn=urn%3Ali%3Afs_miniProfile%3AACoAAB3xymsBeEPhTnyqezOyHDKvJ20VT8I8P7U",
        "postedOn": "2mo",
        "postText": "Excited to share that I have successfully cleared the Project Management Assessment conducted by CareerNinja | LearnTube.",
        "postContentType": "image",
        "postContentLinks": [
            "https://ik.imagekit.io/238r9emirjj/new%20Linkedin%20data/1711504163798.jpg?updatedAt=1746708015324"
        ],
        "postCommentsCount": 2,
        "postLikesCount": 13,
        "postReactionsCount": 13,
        "postHashtags": []
    },
    {
        "url": "https://www.linkedin.com/posts/shushmita-s-775345159_scrummastercertification-scrummaster-everydaylearning-activity-7183398671156174848-BKk6?utm_source=combined_share_message&utm_medium=member_desktop&rcm=ACoAAD484ZYB2sV3_pmVtuTs5T4aCRwQuDMd52w",
        "authorName": "Shushmita S",
        "authorDescription": "Software Engineer - Bank of America | B.Tech,MBA (Gold medal) | Ex-TCS Digital| Contextual Master at TCS",
        "authorProfileImage": "https://ik.imagekit.io/238r9emirjj/new%20Linkedin%20data/1741847062594.jpg?updatedAt=1747055705691",
        "authorProfileLink": "https://www.linkedin.com/in/shushmita-s-775345159?miniProfileUrn=urn%3Ali%3Afs_miniProfile%3AACoAACX1ngkBNkyK0HwOGOtSt8mH3DS_C4PU3mQ",
        "postedOn": "2mo",
        "postText": "Happy to share a small step towards the next goal . \nCareerNinja | LearnTube",
        "postContentType": "image",
        "postContentLinks": [
            "https://ik.imagekit.io/238r9emirjj/new%20Linkedin%20data/1712655703312.jpg?updatedAt=1747055574083"
        ],
        "postCommentsCount": 1,
        "postLikesCount": 18,
        "postReactionsCount": 18,
        "postHashtags": ["#scrummastercertification", "#scrummaster", "#everydaylearning"]
    },
    {
        "url": "https://www.linkedin.com/feed/update/urn:li:activity:7175438779707502592/?actorCompanyId=13328177",
        "authorName": "Mimansha Manya",
        "authorDescription": "Naukri.com | Ex-Amazon",
        "authorProfileImage": "https://ik.imagekit.io/238r9emirjj/new%20Linkedin%20data/1668759197406.jpg?updatedAt=1747117537008",
        "authorProfileLink": "https://www.linkedin.com/in/mimansha-manya-14085b22a?miniProfileUrn=urn%3Ali%3Afs_miniProfile%3AACoAADlvYAABnbl-WKNPoeopXxrgTEEZORA5yxQ",
        "postedOn": "2mo",
        "postText": "I’m happy to share that I’ve obtained a new certification: Digital Marketing Basic from CareerNinja | LearnTube! \n\nThrough this program, I have gained core digital marketing skills and knowledge that I am eager to apply.",
        "postContentType": "image",
        "postContentLinks": [
            "https://ik.imagekit.io/238r9emirjj/new%20Linkedin%20data/1710757917483.jpg?updatedAt=1747117643356"
        ],
        "postCommentsCount": 2,
        "postLikesCount": 33,
        "postReactionsCount": 33,
        "postHashtags": []
    },
    {
        "url": "https://www.linkedin.com/feed/update/urn:li:activity:7282266147075354624/?actorCompanyId=13328177",
        "authorName": "Tanveer Bagga",
        "authorDescription": "Ex Tata Capital| Ex Axis Bank",
        "authorProfileImage": "https://ik.imagekit.io/238r9emirjj/new%20Linkedin%20data/1744031317409.jpg?updatedAt=1747117811938",
        "authorProfileLink": "https://www.linkedin.com/in/tanveer-bagga-67044b1b4?miniProfileUrn=urn%3Ali%3Afs_miniProfile%3AACoAADHmQfQBQjfyUjUVehrU2kFMYR9QykF-eWw",
        "postedOn": "2mo",
        "postText": "I’m happy to share that I’ve obtained a new certification: Social media marketing assessment from LearnTube.ai!",
        "postContentType": "image",
        "postContentLinks": [
            "https://ik.imagekit.io/238r9emirjj/new%20Linkedin%20data/1736227546486.jpg?updatedAt=1747117904497"
        ],
        "postCommentsCount": 3,
        "postLikesCount": 29,
        "postReactionsCount": 29,
        "postHashtags": []
    },
    {
        "url": "https://www.linkedin.com/feed/update/urn:li:activity:7183695579196133378/?actorCompanyId=13328177",
        "authorName": "Anirudh Saravanan",
        "authorDescription": "Senior Engineer at Mercedes-Benz Research and Development India",
        "authorProfileImage": "https://ik.imagekit.io/238r9emirjj/new%20Linkedin%20data/1735201462837%20(1).jpg?updatedAt=1747118860789",
        "authorProfileLink": "https://www.linkedin.com/in/anirudh-saravanan?miniProfileUrn=urn%3Ali%3Afs_miniProfile%3AACoAACxSu5MBRXT2WPEfUXBhBTm3hUwVTYsLYDI",
        "postedOn": "2mo",
        "postText": "Happy to share my certificate on “Project Management” course completion from CareerNinja | LearnTube",
        "postContentType": "image",
        "postContentLinks": [
            "https://ik.imagekit.io/238r9emirjj/new%20Linkedin%20data/1712726491997.jpg?updatedAt=1747118707100"
        ],
        "postCommentsCount": 0,
        "postLikesCount": 16,
        "postReactionsCount": 16,
        "postHashtags": []
    },
    {
        "url": "https://www.linkedin.com/feed/update/urn:li:activity:7182390379474743296/?actorCompanyId=13328177",
        "authorName": "Faiz Yawar",
        "authorDescription": "Deputy Manager at Bajaj Finserv ||Ex-Marketing Intern'24 @ ITC Limited || Learning & Growing || Ex-BYJU'S || Marketing || Finance",
        "authorProfileImage": "https://ik.imagekit.io/238r9emirjj/new%20Linkedin%20data/1704637673833.jpg?updatedAt=1747118064603",
        "authorProfileLink": "https://www.linkedin.com/in/faiz-yawar?miniProfileUrn=urn%3Ali%3Afs_miniProfile%3AACoAADg909sBDh3T35KUJli7Lo2pAu_onfblLiM",
        "postedOn": "2mo",
        "postText": "I'm happy to share that I've obtained a new certification: Data Analytics Assessment from CareerNinja | LearnTube!",
        "postContentType": "image",
        "postContentLinks": [
            "https://ik.imagekit.io/238r9emirjj/new%20Linkedin%20data/Screenshot%202025-05-13%20120715.png?updatedAt=1747118343599"
        ],
        "postCommentsCount": 7,
        "postLikesCount": 9,
        "postReactionsCount": 9,
        "postHashtags": []
    },
    {
        "url": "https://www.linkedin.com/feed/update/urn:li:activity:7190246488105443328/?actorCompanyId=13328177",
        "authorName": "Gokul Ragupathi",
        "authorDescription": "Program Management at Mahindra Aerospace | Product Management | Solid Works | Business Development | Estimation",
        "authorProfileImage": "https://ik.imagekit.io/238r9emirjj/new%20Linkedin%20data/1730368212706.jpg?updatedAt=1747120254397",
        "authorProfileLink": "https://www.linkedin.com/in/gokul-ragu-96vaniyambadi?miniProfileUrn=urn%3Ali%3Afs_miniProfile%3AACoAABd8JLoB_u1CivTHZIOpqQkFrpXGHXE5PUI",
        "postedOn": "2mo",
        "postText": "I’m happy to share that I’ve obtained a new certification: Business Intelligence from CareerNinja | LearnTube! 🎉☮️\n\nIntroduction:\nBusiness Intelligence (BI) refers to the technologies, applications, and practices for the collection, integration, analysis, and presentation of business information. Its purpose is to support better decision-making within organizations by providing insights into their operations, customers, markets, and more.\n\nKey Components of BI\n\n1. Data Warehousing:\nBI typically begins with the collection of data from various sources, which is then stored in a central repository called a data warehouse. This allows for the integration of data from disparate systems and provides a single source of truth for analysis.\n\n2. Data Integration:\nData integration involves the process of combining data from different sources into a unified view. This may involve cleaning, transforming, and reconciling data to ensure its accuracy and consistency.\n\n3. Data Analysis\nOnce the data is integrated, it can be analyzed using various analytical techniques such as reporting, data mining, and predictive analytics. Reporting involves the generation of standard or ad-hoc reports to summarize data, while data mining and predictive analytics uncover hidden patterns and trends within the data.\n\n4. Data Visualization\n Data visualization is the presentation of data in graphical or visual formats such as charts, graphs, and dashboards. This helps users to easily understand and interpret complex data sets.\n\n5. Business Performance Management (BPM)\nBPM involves the measurement and monitoring of key performance indicators (KPIs) to assess the performance of an organization against its goals and objectives. BI tools often include features for BPM, such as scorecards and strategy maps.\n\nBenefits of BI:\n\n1. Improved Decision-Making\n2. Increased Efficiency\n3. Competitive Advantage\n4. Enhanced Customer Satisfaction\n5. Risk Management\n\nChallenges and Considerations\n\n1. Data Quality\n2. Data Security\n3. Complexity\n4. Cost\n5. Change Management\n\nCase Studies\n\n1. Amazon:Amazon uses BI extensively to analyze customer behavior, predict buying patterns, and optimize its product recommendations and pricing strategies.\n\n2. Netflix leverages BI to personalize content recommendations for its users based on their viewing history, preferences, and demographics.\n\n3. Walmart uses BI to optimize its supply chain management, inventory levels, and store operations, resulting in improved efficiency and cost savings.\n\nConclusion:\nBusiness Intelligence is a powerful tool for organizations to gain insights into their operations, customers, and markets, enabling them to make better decisions, improve efficiency, and gain a competitive advantage. However, successful BI implementation requires careful planning, investment, and management to overcome challenges and realize its full potential.",
        "postContentType": "image",
        "postContentLinks": [
            "https://ik.imagekit.io/238r9emirjj/new%20Linkedin%20data/1714288348959.jpg?updatedAt=1747120407922"
        ],
        "postCommentsCount": 12,
        "postLikesCount": 21,
        "postReactionsCount": 21,
        "postHashtags": []
    },
    {
        "url": "https://www.linkedin.com/feed/update/urn:li:activity:7179632461067300865/?actorCompanyId=13328177",
        "authorName": "Ankit Dubey",
        "authorDescription": "Adobe | Ex- American Express GBT, Amazon | Certified Scrum Product Owner | Power BI | Tableau | Alteryx | Power Automate | SQL | Six Sigma | Generative AI |",
        "authorProfileImage": "https://ik.imagekit.io/238r9emirjj/new%20Linkedin%20data/1744004981905.jpg?updatedAt=1747120559424",
        "authorProfileLink": "https://www.linkedin.com/in/ankitdubey6?miniProfileUrn=urn%3Ali%3Afs_miniProfile%3AACoAABv2-qkBLYu1wPF_AhsZFWf2A9XaSU2KMRE",
        "postedOn": "2mo",
        "postText": "CareerNinja | LearnTube",
        "postContentType": "image",
        "postContentLinks": [
            "https://ik.imagekit.io/238r9emirjj/new%20Linkedin%20data/Screenshot%202025-05-13%20124839.png?updatedAt=1747120758246"
        ],
        "postCommentsCount": 0,
        "postLikesCount": 16,
        "postReactionsCount": 16,
        "postHashtags": []
    },
    {
        "url": "https://www.linkedin.com/feed/update/urn:li:activity:7280077363382566912/?actorCompanyId=13328177",
        "authorName": "Sagar Shah PMP® CSM®",
        "authorDescription": "LinkedIn Top Agile Voice | Technology Evangelist | IT Consultant | Agile Mentor | Digital Transformation | Prompt Engineering | SAFe - Scaled Agile Framework | Pre-Sales Consultant | RFP Specialist | 10K+ Followers",
        "authorProfileImage": "https://ik.imagekit.io/238r9emirjj/new%20Linkedin%20data/1687925732940.jpg?updatedAt=1747121068982",
        "authorProfileLink": "https://www.linkedin.com/in/shahsagar27?miniProfileUrn=urn%3Ali%3Afs_miniProfile%3AACoAAASVsJsBjIk4nYyaQLHsyuSxbDFfIsgPiGo",
        "postedOn": "2mo",
        "postText": "🎉𝗘𝘅𝗰𝗶𝘁𝗲𝗱 𝘁𝗼 𝗦𝗵𝗮𝗿𝗲 𝗮 𝗠𝗶𝗹𝗲𝘀𝘁𝗼𝗻𝗲! 🎓\n\nI’m thrilled to announce that I’ve successfully obtained the 𝗠𝗮𝗰𝗵𝗶𝗻𝗲 𝗟𝗲𝗮𝗿𝗻𝗶𝗻𝗴 𝗔𝘀𝘀𝗲𝘀𝘀𝗺𝗲𝗻𝘁 Certification from LearnTube.ai! 🚀\n\nThis certification has deepened my understanding of machine learning concepts and practices, from foundational algorithms to advanced applications. It’s been an incredible learning journey, and I’m excited to apply these skills to real-world challenges and contribute to innovative solutions.\n\nA big thank you to LearnTube.ai for creating a platform that offers practical and in-depth learning experiences. 🌟\n\nLooking forward to connecting with fellow enthusiasts in the field and exploring new opportunities in the exciting world of machine learning!",
        "postContentType": "image",
        "postContentLinks": [
            "https://ik.imagekit.io/238r9emirjj/new%20Linkedin%20data/1735705699842.jpg?updatedAt=1747121174854"
        ],
        "postCommentsCount": 9,
        "postLikesCount": 38,
        "postReactionsCount": 38,
        "postHashtags": ["#Certification", "#MachineLearning", "#AI", "#ContinuousLearning", "#ProfessionalGrowth", "#LearntubeAI"]
    },
    {
        "url": "https://www.linkedin.com/feed/update/urn:li:activity:7291997141303013376/?actorCompanyId=13328177",
        "authorName": "K Viritha",
        "authorDescription": "Sr Associate analyst at Tech Mahindra,Six sigma assessment certification Academic coordinator at Slate The School, Medical Imaging at PAREXEL.",
        "authorProfileImage": "https://ik.imagekit.io/238r9emirjj/new%20Linkedin%20data/1746494429116.jpg?updatedAt=1747123133595",
        "authorProfileLink": "https://www.linkedin.com/in/k-viritha-a26987278?miniProfileUrn=urn%3Ali%3Afs_miniProfile%3AACoAAEPGqP4BH0ZiJpgI70qQY9dBTyd9B3Nqvno",
        "postedOn": "2mo",
        "postText": "Learning is the only thing the mind never exhausts, never fears, and never regrets.\n\nThanks LeanTube for the great learning platform,this is my 4th certification from Learntube 😊",
        "postContentType": "image",
        "postContentLinks": [
            "https://ik.imagekit.io/238r9emirjj/new%20Linkedin%20data/1738547595697.jpg?updatedAt=1747123803975"
        ],
        "postCommentsCount": 5,
        "postLikesCount": 13,
        "postReactionsCount": 13,
        "postHashtags": ["#operations management", "#learntube", "#LearnTube.ai"]
    },
    {
        "url": "https://www.linkedin.com/feed/update/urn:li:activity:7282084633079410693/?actorCompanyId=13328177",
        "authorName": "Siddharth Kamath 🇮🇳",
        "authorDescription": "2X Salesforce Certified ☁️ | Experienced in CRM & Project Management 💻 | Process Improvement & Excellence ♻️ | Business Analytics 📊📉 | Client Servicing Operations ⚙️ | Sales & Marketing ✒️ | Event Management 🎭 |",
        "authorProfileImage": "https://ik.imagekit.io/238r9emirjj/new%20Linkedin%20data/1656136386946.jpg?updatedAt=1747126701181",
        "authorProfileLink": "https://www.linkedin.com/in/savagesidd?miniProfileUrn=urn%3Ali%3Afs_miniProfile%3AACoAADQpBVsBephwHefA0ugbP_yUvx0nn4rGZ-g",
        "postedOn": "2mo",
        "postText": "Happy to share that I’ve completed the \"Essentials of Project Management\" certification by LearnTube.ai | CareerNinja's Digital Institute  powered by Google.\n\nThis course covered the basics of planning, task management, collaboration, risk management, and resource optimization. It’s helped me understand how clear goals, effective planning, and proactive problem-solving can make a big difference in managing projects successfully.\n\nI’m looking forward to applying these learnings in my day-to-day work—whether it’s managing priorities, streamlining tasks, or working with teams more efficiently. Excited to keep learning and growing from here!\n\n",
        "postContentType": "image",
        "postContentLinks": [
            "https://ik.imagekit.io/238r9emirjj/new%20Linkedin%20data/1736184269498.jpg?updatedAt=1747126854606"
        ],
        "postCommentsCount": 16,
        "postLikesCount": 55,
        "postReactionsCount": 55,
        "postHashtags": ["#projectmanagement", "#skillingup", "#learning"]
    },
    {
        "url": "https://www.linkedin.com/feed/update/urn:li:activity:7180275869712621568/?actorCompanyId=13328177",
        "authorName": "Aadarsh K.",
        "authorDescription": "Business Analyst at HCL Healthcare || SQL || Excel || Python || Power BI",
        "authorProfileImage": "https://ik.imagekit.io/238r9emirjj/new%20Linkedin%20data/1722357913576.jpg?updatedAt=1747127350252",
        "authorProfileLink": "https://www.linkedin.com/in/aadarshkatiyar?miniProfileUrn=urn%3Ali%3Afs_miniProfile%3AACoAADXWAK8BGNmFTujuMHFZ5tAD0ePyW2D8Dm0",
        "postedOn": "2mo",
        "postText": "I’m happy to share that I’ve obtained a new certification: Data Analytics from CareerNinja | LearnTube!",
        "postContentType": "image",
        "postContentLinks": [
            "https://ik.imagekit.io/238r9emirjj/new%20Linkedin%20data/1711911168611.jpg?updatedAt=1747127532363"
        ],
        "postCommentsCount": 4,
        "postLikesCount": 4,
        "postReactionsCount": 4,
        "postHashtags": ["#dataanalytics", "#analyst", "#DataScientist", "#CareerNinja"]
    },
    {
        "url": "https://www.linkedin.com/feed/update/urn:li:activity:7178447547462557697/?actorCompanyId=13328177",
        "authorName": "Shounak Singh",
        "authorDescription": "Pilot-in-Command @ixigo.com",
        "authorProfileImage": "https://ik.imagekit.io/238r9emirjj/new%20Linkedin%20data/1697824186284.jpg?updatedAt=1747127658492",
        "authorProfileLink": "https://www.linkedin.com/in/shounak-singh?miniProfileUrn=urn%3Ali%3Afs_miniProfile%3AACoAAA03-7EBaooyXZDHx3P3lMJR-Vdo2tkTV9o",
        "postedOn": "2mo",
        "postText": "I’m happy to share that I’ve obtained a new certification: Project Management Certificate from CareerNinja | LearnTube!",
        "postContentType": "image",
        "postContentLinks": [
            "https://ik.imagekit.io/238r9emirjj/new%20Linkedin%20data/1711475263311.jpg?updatedAt=1747127863803"
        ],
        "postCommentsCount": 19,
        "postLikesCount": 38,
        "postReactionsCount": 38,
        "postHashtags": []
    },
    {
        "url": "https://www.linkedin.com/feed/update/urn:li:activity:7192024275657093120/?actorCompanyId=13328177",
        "authorName": "Sandesh Goyal",
        "authorDescription": "Fincrime Team Leader-L1 at Revolut ||EX-Taskus Operations Team Leader",
        "authorProfileImage": "https://ik.imagekit.io/238r9emirjj/new%20Linkedin%20data/1737979165391.jpg?updatedAt=1747128007415",
        "authorProfileLink": "https://www.linkedin.com/in/sandesh-goyal-153356209?miniProfileUrn=urn%3Ali%3Afs_miniProfile%3AACoAADTpMk8BZAhcIvGOEJLhMu8TAy22DMbIeh4",
        "postedOn": "2mo",
        "postText": "I’m happy to share that I’ve obtained a new certification: Project Management from CareerNinja | LearnTube!",
        "postContentType": "image",
        "postContentLinks": [
            "https://ik.imagekit.io/238r9emirjj/new%20Linkedin%20data/1714712207681.jpg?updatedAt=1747128134585"
        ],
        "postCommentsCount": 7,
        "postLikesCount": 54,
        "postReactionsCount": 54,
        "postHashtags": []
    },
    {
        "url": "https://www.linkedin.com/feed/update/urn:li:activity:7183151250484420608/?actorCompanyId=13328177",
        "authorName": "Mayank Joshi",
        "authorDescription": "Ops Support Specialist @ Amazon | MBA in Operations Management",
        "authorProfileImage": "https://ik.imagekit.io/238r9emirjj/new%20Linkedin%20data/1678866931424.jpg?updatedAt=1747128284683",
        "authorProfileLink": "https://www.linkedin.com/in/mayank-joshi-baa515186?miniProfileUrn=urn%3Ali%3Afs_miniProfile%3AACoAACvb1XIBRRCmsj7oJcht-pjuv3fCNyStGxc",
        "postedOn": "2mo",
        "postText": "I’m happy to share that I’ve obtained a new certification: Project Management Assesment from CareerNinja | LearnTube!",
        "postContentType": "image",
        "postContentLinks": [
            "https://ik.imagekit.io/238r9emirjj/new%20Linkedin%20data/1712596713547.jpg?updatedAt=1747128366359"
        ],
        "postCommentsCount": 0,
        "postLikesCount": 7,
        "postReactionsCount": 7,
        "postHashtags": []
    },
    {
        "url": "https://www.linkedin.com/feed/update/urn:li:activity:7123615775164182530/?actorCompanyId=13328177",
        "authorName": "Taksh Jodhani, CSM®",
        "authorDescription": "Business Analyst @ Pacific Group of Companies | Certified Scrum Master",
        "authorProfileImage": "https://ik.imagekit.io/238r9emirjj/new%20Linkedin%20data/1619023153011.jpg?updatedAt=1747133691357",
        "authorProfileLink": "https://www.linkedin.com/in/taksh-jodhani?miniProfileUrn=urn%3Ali%3Afs_miniProfile%3AACoAACYwctEBujemsmRILMVxtyyiVzNmbXiBPD4",
        "postedOn": "2mo",
        "postText": "I’m happy to share that I’ve obtained a new certification: Scrum Master Certified (SMC) from CareerNinja | LearnTube!\n\nExcited to enhance my Agile and project management skills.\n\n#ScrumMasterCertified #Agile #CareerNinja",
        "postContentType": "image",
        "postContentLinks": [
            "https://ik.imagekit.io/238r9emirjj/new%20Linkedin%20data/1698402349205.jpg?updatedAt=1747133778019"
        ],
        "postCommentsCount": 9,
        "postLikesCount": 57,
        "postReactionsCount": 57,
        "postHashtags": []
    },
    {
        "url": "https://www.linkedin.com/feed/update/urn:li:activity:7191992468689547265/?actorCompanyId=13328177",
        "authorName": "Shristi Shandilya",
        "authorDescription": "SDE-IV @ Phreesia | Crafting Exceptional UI Experiences | Formerly Morgan Stanley, Nykaa, Cashify | Passionate about Perfecting User Interfaces",
        "authorProfileImage": "https://ik.imagekit.io/238r9emirjj/new%20Linkedin%20data/1646547299171.jpg?updatedAt=1747134008036",
        "authorProfileLink": "https://www.linkedin.com/in/shristi-shandilya-a1457336?miniProfileUrn=urn%3Ali%3Afs_miniProfile%3AACoAAAeO7PABwT9C_0m4rK08drC30e9gcqifi3c",
        "postedOn": "2mo",
        "postText": "Thanks to CareerNinja | LearnTube   for providing me with the Scrum Master Assessment Certification, This is a Kickstart to learn n addon new skills",
        "postContentType": "image",
        "postContentLinks": [
            "https://ik.imagekit.io/238r9emirjj/new%20Linkedin%20data/Screenshot%202025-05-13%20163200.png?updatedAt=1747134151835"
        ],
        "postCommentsCount": 0,
        "postLikesCount": 17,
        "postReactionsCount": 17,
        "postHashtags": []
    },

]